module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e554"
    }
  }, [_vm._v("First Edition"), _c('br'), _vm._v("10 09 08       5 4 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e634"
    }
  }, [_vm._v("Text © 2006 by Michelle Gringeri-Brown"), _c('br'), _vm._v("Photographs © 2006 by Jim Brown ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e844"
    }
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e974"
    }
  }, [_vm._v("Published by"), _c('br'), _vm._v("Gibbs Smith, Publisher"), _c('br'), _vm._v("P.O. Box 667"), _c('br'), _vm._v("Layton, Utah 84041 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1144"
    }
  }, [_vm._v("Orders: 1.800.748.5439"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.gibbs-smith.com",
      "id": "d14e76",
      "target": "_blank"
    }
  }, [_vm._v("www.gibbs-smith.com")])]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1274"
    }
  }, [_vm._v("Designed by Deibra McQuiston"), _c('br'), _vm._v("Printed and bound in China ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1384"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data"), _c('br'), _vm._v("Gringeri-Brown, Michelle."), _c('br'), _vm._v("Atomic ranch : design ideas for stylish ranch homes /Michelle Gringeri-Brown;"), _c('br'), _vm._v("photographs by Jim Brown.-—1st ed."), _c('br'), _vm._v("     p. cm."), _c('br'), _vm._v("   ISBN 10: 1-4236-0002-9 : ISBN 13: 978-1-4236-0002-2"), _c('br'), _vm._v("   1. Ranch houses—United States. 2. Architecture—United States—20th century."), _c('br'), _vm._v("I. Title.")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e1894"
    }
  }, [_vm._v("NA7208.G75 2006"), _c('br'), _vm._v("728'.3730973--dc22 ")]), _vm._v(" "), _c('p', {
    staticClass: "crt",
    attrs: {
      "id": "d7e2044"
    }
  }, [_vm._v("2006004614 ")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    attrs: {
      "alt": "AtomicRanchBook_0004_002",
      "id": "d14e105",
      "src": "images/AtomicRanchBook_0004_002.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55ff38ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grin_ISBN9781423600022_epub_c5_r1.vue
// module id = 69
// module chunks = 0